// Entry point for esbuild bundling
// Bootstrap JS (dropdown, collapse) requires jQuery in Bootstrap 4
import jquery from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import Rails from '@rails/ujs';

// Expose jQuery globals expected by Bootstrap plugins
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.$ = window.jQuery = jquery;
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Rails UJS so data-method/delete links (e.g., logout) work
  if (!Rails.started) Rails.start();
  const container = document.getElementById('react-root');
  if (!container) return;
  const disableLogger = container.dataset.disableLogger === 'true';
  const root = createRoot(container);
  root.render(
    React.createElement(App, { disableLogger })
  );
});
